import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://ddda78ec21b6c1b3a13a1cef5fd644db@o4509134310932480.ingest.de.sentry.io/4509393961615440",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0,
  integrations: [Sentry.browserTracingIntegration()],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()